(() => {

const initReveals = container => {
  var root = container;
  if (!root || !('IntersectionObserver' in window) || !Element.prototype.animate || (window.Shopify && Shopify.designMode)) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches) return;
  var animations = new Map();
  var groups = Array.from(root.querySelectorAll('.five-reasons__hero-copy, .five-reasons__intro-inner, .glass-quote, .five-reasons__reason-head, .five-reasons__reason-body, .five-reasons__badges, .glass-feature-grid, .glass-faq > .page-width'));
  groups.forEach(function (group) {
    var elements = Array.from(group.children).filter(function (element) { return !['STYLE', 'SCRIPT'].includes(element.tagName); });
    elements = elements.flatMap(function (element) {
      return element.matches('.five-reasons__copy, .five-reasons__system-copy, .five-reasons__badge-list') ? Array.from(element.children) : [element];
    });
    var sequence = elements.map(function (element, index) {
      var animation = element.animate(
        [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 1400, delay: index * 130, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'both' }
      );
      animation.pause();
      animation.currentTime = 0;
      animation.onfinish = function () { animation.cancel(); };
      return animation;
    });
    animations.set(group, sequence);
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (motion.matches) return;
      var sequence = animations.get(entry.target);
      if (sequence) sequence.forEach(function (animation) { animation.play(); });
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
  groups.forEach(function (group) { observer.observe(group); });
  function stop() {
    observer.disconnect();
    animations.forEach(function (sequence) { sequence.forEach(function (animation) { animation.cancel(); }); });
    animations.clear();
  }
  function changed() { if (motion.matches) stop(); }
  motion.addEventListener('change', changed);
  root.addEventListener('shopify:section:unload', function () {
    stop();
    motion.removeEventListener('change', changed);
  }, { once: true });
};

  const init = root => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    initReveals(root);
    const checkoutLinks = [...root.querySelectorAll('a.glass-checkout')];
    const checkoutLabels = checkoutLinks.map(link => link.textContent);
    let checkoutPending = false;
    let checkoutTimeout;
    const resetCheckout = () => {
      clearTimeout(checkoutTimeout);
      checkoutPending = false;
      root.classList.remove('is-checking-out');
      checkoutLinks.forEach((link, index) => {
        link.textContent = checkoutLabels[index];
        link.removeAttribute('aria-disabled');
        link.removeAttribute('aria-busy');
      });
    };
    const beginCheckout = event => {
      if (checkoutPending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      // Preserve normal new-tab and modified-link behavior.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      checkoutPending = true;
      root.classList.add('is-checking-out');
      checkoutLinks.forEach(link => {
        link.textContent = 'PREPARING YOUR CHECKOUT...';
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('aria-busy', 'true');
      });
      // Let the original checkout link navigate without an added request or delay.
      checkoutTimeout = setTimeout(() => {
        resetCheckout();
      }, 30000);
    };
    checkoutLinks.forEach(link => link.addEventListener('click', beginCheckout, true));
    window.addEventListener('pageshow', resetCheckout);
    const ticker = root.querySelector('.glass-ticker');
    const tickerGroup = ticker.querySelector('.glass-ticker-group');
    const updateTicker = () => {
      ticker.classList.remove('is-overflowing');
      ticker.classList.toggle('is-overflowing', tickerGroup.scrollWidth > ticker.clientWidth);
    };
    const tickerResize = new ResizeObserver(updateTicker);
    tickerResize.observe(ticker);
    document.fonts.ready.then(updateTicker);
    updateTicker();
    const track = root.querySelector('.glass-gallery-track');
    const buttons = [...root.querySelectorAll('[data-slide]')];
    const count = root.querySelector('.glass-gallery-count');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const thumbnails = root.querySelector('.glass-thumbnails');
    const thumbnailNav = root.querySelector('.glass-thumbnail-nav');
    const thumbnailPrev = root.querySelector('[data-thumbnail-prev]');
    const thumbnailNext = root.querySelector('[data-thumbnail-next]');
    const updateThumbnailNav = () => {
      thumbnailNav.classList.toggle('is-overflowing', buttons.length * 70 - 6 > thumbnailNav.clientWidth);
      thumbnailPrev.disabled = thumbnails.scrollLeft <= 1;
      thumbnailNext.disabled = thumbnails.scrollLeft + thumbnails.clientWidth >= thumbnails.scrollWidth - 1;
    };
    const revealThumbnail = index => {
      const button = buttons[index];
      if (!button) return;
      const viewport = thumbnails.getBoundingClientRect();
      const rect = button.getBoundingClientRect();
      const offset = rect.left < viewport.left ? rect.left - viewport.left : rect.right > viewport.right ? rect.right - viewport.right : 0;
      if (offset) thumbnails.scrollBy({left: offset, behavior: reduced.matches ? 'instant' : 'smooth'});
    };
    const scrollThumbnails = direction => thumbnails.scrollBy({left: direction * Math.max(70, thumbnails.clientWidth - 70), behavior: reduced.matches ? 'instant' : 'smooth'});
    thumbnailPrev.addEventListener('click', () => scrollThumbnails(-1));
    thumbnailNext.addEventListener('click', () => scrollThumbnails(1));
    thumbnails.addEventListener('scroll', updateThumbnailNav, {passive: true});
    thumbnails.addEventListener('focusin', event => {
      const index = buttons.indexOf(event.target);
      if (index >= 0) revealThumbnail(index);
    });
    const thumbnailResize = new ResizeObserver(() => { updateThumbnailNav(); revealThumbnail(activeIndex); });
    let activeIndex = -1;
    thumbnailResize.observe(thumbnailNav);
    thumbnailResize.observe(thumbnails);
    const go = index => track.scrollTo({left: track.clientWidth * index, behavior: reduced.matches ? 'instant' : 'smooth'});
    buttons.forEach((button, index) => button.addEventListener('click', () => go(index)));
    let frame;
    const update = () => {
      if (!buttons.length || !track.clientWidth) return;
      const index = Math.max(0, Math.min(buttons.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      if (index !== activeIndex) { activeIndex = index; revealThumbnail(index); }
      count.textContent = (index + 1) + ' / ' + buttons.length + ' · swipe →';
    };
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
    track.addEventListener('keydown', event => {
      if (!buttons.length) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      let index = Math.round(track.scrollLeft / track.clientWidth);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      go(Math.max(0, Math.min(buttons.length - 1, index)));
    });
    const resize = new ResizeObserver(update);
    resize.observe(track);
    const sticky = root.querySelector('.glass-sticky');
    const buy = root.querySelector('.glass-buy-info .glass-checkout, .glass-buy-info button');
    const revealImage = root.querySelector('.five-reasons__reason-image');
    let stickyFrame;
    const updateSticky = () => {
      const imageRect = revealImage.getBoundingClientRect();
      const buyRect = buy.getBoundingClientRect();
      const buyVisible = buyRect.top < window.innerHeight && buyRect.bottom > 0;
      const visible = window.matchMedia('(max-width:767px)').matches && imageRect.top < window.innerHeight && !buyVisible;
      sticky.classList.toggle('is-visible', visible);
      sticky.inert = !visible;
      sticky.setAttribute('aria-hidden', String(!visible));
    };
    const scheduleSticky = () => {
      cancelAnimationFrame(stickyFrame);
      stickyFrame = requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll', scheduleSticky, {passive:true});
    window.addEventListener('resize', scheduleSticky);
    const layoutObserver = new ResizeObserver(scheduleSticky);
    layoutObserver.observe(root);
    updateSticky();
    root.closest('.shopify-section').addEventListener('shopify:section:unload', () => {
      resetCheckout();
      window.removeEventListener('pageshow', resetCheckout);
      checkoutLinks.forEach(link => link.removeEventListener('click', beginCheckout, true));
      resize.disconnect();
      thumbnailResize.disconnect();
      tickerResize.disconnect();
      layoutObserver.disconnect();
      window.removeEventListener('scroll', scheduleSticky);
      window.removeEventListener('resize', scheduleSticky);
      cancelAnimationFrame(frame);
      cancelAnimationFrame(stickyFrame);
    }, {once:true});
  };
  const start = () => document.querySelectorAll('[data-glass-lp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();